import compact from 'lodash/compact'
import find from 'lodash/find'
import map from 'lodash/map'
import { useRouter } from 'next/router'
import React, { FC, memo } from 'react'

import { BaseAttribute, Product } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductUsps.module.scss'

export type DescriptionItem = Record<string, string>

interface ProductUSPsProps {
  buyTwoAllowed?: boolean
  buyTwoEnabled?: boolean
  product: Product
}

export const ProductUSPs: FC<ProductUSPsProps> = memo(({
  buyTwoAllowed,
  buyTwoEnabled,
  product,
}) => {
  const { locale = 'en-GB' } = useRouter()

  const { t } = useTranslation()

  const uniqueSellingPoints = ((find(product?.masterVariant?.attributes, ['key', 'descriptionItems']) as BaseAttribute)?.value || []) as DescriptionItem[]

  const descriptionsToRender = compact(map(uniqueSellingPoints, descriptionItem => descriptionItem[locale]))

  return (
    <div className={styles.usps}>
      <ul className={styles.list}>
        {buyTwoAllowed && !buyTwoEnabled && (
          <li>{t('products:PP_PRICE_IS_FOR_ONE_PIECE')}</li>
        )}
        {map(descriptionsToRender, item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  )
})
